import React, { useState, useEffect } from 'react';
import { Card, Tabs, Tab, Badge } from 'react-bootstrap'
import AdditionalInformationPage from './AdditionalInformation/AdditionalInformationPage';
import CredentialHistoryTable from './CredentialHistoryTable';
import EducationPage from './Education/EducationPage';
import EntityInformationPage from './EntityInformationPage';
import EntityAttachments from './EntityAttachments';
import ExamsPage from './Exams/ExamsPage';
import FeeTransactionPage from './FeeTransactionPage';
import WarningsPage from './Warnings/WarningsPage';
import EntityEnforcementAttachments from './EntityEnforcementAttachments';

function TopInformationCard(props) {
    const [activeSection, setActiveSection] = useState('entityInfo')
    const [warningNumber, setWarningNumber] = useState(0);
    const [attachmentsBold, setAttachmentsBold] = useState(false);
    const [enforcementAttachmentsBold, setEnforcementAttachmentsBold] = useState(false);
    const [credHistoryBold, setCredHistoryBold] = useState(false);
    const [additionalInformationBold, setAdditionalInformationBold] = useState(false);
    const [feeTransactionsBold, setFeeTransactionsBold] = useState(false);
    const [examsBold, setExamsBold] = useState(false);
    const [educationBold, setEducationBold] = useState(false);
    const [warningsBold, setWarningsBold] = useState(false);
    const warningTitle =
        <>
            <span className={warningsBold ? "boldTopTab" : ""}>WARNING(S)</span>
            {warningNumber > 0 &&
                <Badge style={{ borderRadius: '10em', paddingRight: '.5em', paddingLeft: '.5em' }} bg="danger">{warningNumber}</Badge >
            }
        </>;
    const educationTitle = <>
        <span className={educationBold ? "boldTopTab" : ""}>EDUCATION</span>
    </>
    const examTitle = <>
        <span className={examsBold ? "boldTopTab" : ""}>EXAMS</span>
    </>
    const additionalInformationTitle = <>
        <span className={additionalInformationBold ? "boldTopTab" : ""}>ADDITIONAL INFORMATION</span>
    </>
    const feeTransactionsTitle = <>
        <span className={feeTransactionsBold ? "boldTopTab" : ""}>FEE TRANSACTIONS</span>
    </>
    const credHistoryTitle = <>
        <span className={credHistoryBold ? "boldTopTab" : ""}>CREDENTIAL HISTORY</span>
    </>
    const laserficheTitle = <>
        <span className={attachmentsBold ? "boldTopTab" : ""}>LASERFICHE</span>
    </>
    const enforcementTitle = <>
        <span className={enforcementAttachmentsBold ? "boldTopTab" : ""}>LASERFICHE ENFORCEMENT</span>
    </>

    return (
        <Card className="w-100">
            <Card.Body>
                <Tabs activeKey={activeSection} transition={false} onSelect={(selected) => { setActiveSection(selected) }} className='credentialNav'>
                    <Tab eventKey='entityInfo' title='ENTITY INFORMATION'>
                        <br />
                        <EntityInformationPage entityId={props.entityId} activeKey={activeSection} />
                    </Tab>
                    <Tab eventKey='warnings' title={warningTitle}>
                        <br />
                        <WarningsPage entityId={props.entityId} setWarningNumber={setWarningNumber} activeKey={activeSection} setTabBoldness={setWarningsBold} />
                    </Tab>
                    {props.isIndividual &&
                        <Tab eventKey='education' title={educationTitle}>
                        <br />
                        <EducationPage entityId={props.entityId} activeKey={activeSection} setTabBoldness={setEducationBold} />
                        </Tab>
                    }
                    {props.isIndividual &&
                        <Tab eventKey='exams' title={examTitle}>
                        <br />
                        <ExamsPage entityId={props.entityId} activeKey={activeSection} setTabBoldness={setExamsBold} />
                        </Tab>
                    }
                    <Tab eventKey='feeTransactions' title={feeTransactionsTitle}>
                        <br />
                        <FeeTransactionPage isIndividual={props.isIndividual} entityId={props.entityId} activeKey={activeSection} setTabBoldness={setFeeTransactionsBold} />
                    </Tab>
                    {props.isIndividual &&
                        <Tab eventKey='additionalInformation' title={additionalInformationTitle}>
                        <br />
                        <AdditionalInformationPage entityId={props.entityId} activeKey={activeSection} setTabBoldness={setAdditionalInformationBold} />
                        </Tab>
                    }
                    <Tab eventKey='credHistory' title={credHistoryTitle}>
                        <br />
                        <CredentialHistoryTable entityId={props.entityId} activeKey={activeSection} showLicenseNumber={true} setTabBoldness={setCredHistoryBold} fromTopCard={true} />
                    </Tab>
                    <Tab eventKey='attachments' title={laserficheTitle}>
                        <br />
                        <EntityAttachments entityId={props.entityId} activeKey={activeSection} setTabBoldness={setAttachmentsBold} />
                    </Tab>
                    <Tab eventKey='enforcementAttachments' title={enforcementTitle}>
                        <br />
                        <EntityEnforcementAttachments isIndividual={props.isIndividual} entityId={props.entityId} activeKey={activeSection} setTabBoldness={setEnforcementAttachmentsBold} />
                    </Tab>
                </Tabs>
            </Card.Body>
        </Card >
    )
}


export default TopInformationCard;